export const socialLinks = [
  {
    id: 1,
    name: 'instagram',
    label: 'storeManagement.form.sns.label.instagram',
    placeholder: 'www.instagram.com',
  },
  { id: 2, name: 'tiktok', label: 'storeManagement.form.sns.label.tiktok', placeholder: 'www.tiktok.com' },
  { id: 3, name: 'twitter', label: 'storeManagement.form.sns.label.x', placeholder: 'www.twitter.com' },
  { id: 4, name: 'line', label: 'storeManagement.form.sns.label.line', placeholder: 'www.line.com/+09033333333' },
  { id: 5, name: 'website', label: 'storeManagement.form.sns.label.website', placeholder: 'www.website.com' },
  { id: 6, name: 'googleMap', label: 'storeManagement.form.sns.label.googleMap', placeholder: 'www.googlemap.com' },
];

export const holidays = [
  { value: '1', label: 'Sunday' },
  { value: '2', label: 'Monday' },
  { value: '3', label: 'Tuesday' },
  { value: '4', label: 'Wednesday' },
  { value: '5', label: 'Thursday' },
  { value: '6', label: 'Friday' },
  { value: '7', label: 'Saturday' },
];

export const closingDateOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
  { label: '15', value: '15' },
  { label: '16', value: '16' },
  { label: '17', value: '17' },
  { label: '18', value: '18' },
  { label: '19', value: '19' },
  { label: '20', value: '20' },
  { label: '21', value: '21' },
  { label: '22', value: '22' },
  { label: '23', value: '23' },
  { label: '24', value: '24' },
  { label: '25', value: '25' },
  { label: '26', value: '26' },
  { label: '27', value: '27' },
  { label: '28', value: '28' },
  { label: '29', value: '29' },
  { label: '30', value: '30' },
  { label: '31', value: '31' },
];

export const businessInfoLabels = [
  { id: 1, name: 'ceoName', label: 'storeManagement.form.businessInfo.label.ceoName' },
  { id: 2, name: 'ceoNameFurigana', label: 'storeManagement.form.businessInfo.label.furigana' },
  { id: 3, name: 'companyName', label: 'storeManagement.form.businessInfo.label.companyName' },
  { id: 4, name: 'companyNameFurigana', label: 'storeManagement.form.businessInfo.label.furigana' },
  { id: 5, name: 'companyAddress', label: 'storeManagement.form.businessInfo.label.companyAddress' },
  { id: 6, name: 'landlineNumber', label: 'storeManagement.form.businessInfo.label.landlineNumber' },
  { id: 7, name: 'mobileNumber', label: 'storeManagement.form.businessInfo.label.mobileNumber' },
  { id: 8, name: 'emailAddress', label: 'storeManagement.form.businessInfo.label.emailAddress' },
  { id: 9, name: 'username', label: 'storeManagement.form.businessInfo.label.username' },
];
